import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomDataTable,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { FiDownload } from 'react-icons/fi'
import useRelatorioEstoquePorProduto, { LOAD_MESSAGE } from './RelatorioEstoquePorProdutoHook'

function RelatorioEstoquePorProduto({ dispatch, history, selectedTp }) {
  const { state, setState, localDispatch } = useRelatorioEstoquePorProduto()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>8.22 - Relatório de Estoque por Produto</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <Fieldset legend="Filtros" toggleable collapsed={false} style={{ marginBottom: 20 }}>
            <div className="p-grid p-align-end">
              <div className="p-col-3">
                <CustomMultiSelect
                  label="Estoque"
                  options={state.estoqueOptions}
                  value={state.selectedEstoques}
                  onChange={value => setState(prev => ({ ...prev, selectedEstoques: value }))}
                  filter={true}
                  filterPlaceholder="Buscar estoque..."
                />
              </div>
              <div className="p-col-3">
                <CustomMultiSelect
                  label="Posição de Estoque"
                  options={state.posicaoOptions}
                  value={state.selectedPosicoes}
                  onChange={value => setState(prev => ({ ...prev, selectedPosicoes: value }))}
                  filter={true}
                  filterPlaceholder="Buscar posição..."
                />
              </div>
              <div className="p-col-3">
                <CustomMultiSelect
                  label="Empresa"
                  options={state.empresaOptions}
                  value={state.selectedEmpresas}
                  onChange={value => setState(prev => ({ ...prev, selectedEmpresas: value }))}
                  filter={true}
                  filterPlaceholder="Buscar empresa..."
                />
              </div>
              <div className="p-col-3">
                <CustomMultiSelect
                  label="Produto"
                  options={state.produtoOptions}
                  value={state.selectedProdutos}
                  onChange={value => setState(prev => ({ ...prev, selectedProdutos: value }))}
                  filter={true}
                  filterPlaceholder="Buscar produto..."
                />
              </div>
            </div>
          </Fieldset>

          <div style={{ marginTop: 16, marginBottom: 16 }}>
            <Btn
              disabled={!state.filteredRows.length}
              onClick={() => localDispatch.exportExcel(state.filteredRows)}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FiDownload size={18} />
                <span style={{ marginLeft: 5 }}>Exportar</span>
              </div>
            </Btn>
          </div>

          <CustomDataTable
            value={state.filteredRows}
            paginator={true}
            rows={15}
            emptyMessage="Nenhum dado encontrado"
            header={
              <CustomDataTableHeader
                onChange={value => localDispatch.onGlobalFilterChange(value)}
              />
            }
            globalFilter={state.globalFilter}
            responsive={true}
          >
            <Column field="estoque_name" header="Estoque" style={tableCellCentered()} />
            <Column field="endereco" header="Posição" style={tableCellCentered()} />
            <Column field="company_name" header="Empresa" style={tableCellCentered()} />
            <Column field="product_code" header="Código" style={tableCellCentered()} />
            <Column field="product_name" header="Produto" style={tableCellCentered()}/>
            <Column field="quantidade" header="QTD Atual" style={tableCellCentered()} />
            <Column
              field="estoque_minimo"
              header="Estoque Mínimo"
              style={tableCellCentered()}
              body={row => (row.estoque_minimo != null ? row.estoque_minimo : '-')}
            />
            <Column field="validade" header="Validade" style={tableCellCentered()} />
            <Column field="lote" header="Lote" style={tableCellCentered()} />
          </CustomDataTable>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioEstoquePorProduto))
